module.exports = __webpack_public_path__ + "static/media/uz.9588be17.svg";